import { useState } from 'react'
import { FaBoxOpen } from "react-icons/fa6";
import { useFormik } from "formik";
import { BsBoxFill } from "react-icons/bs";
import { Link } from 'react-router-dom';
import * as Yup from 'yup';
import { useLazyQuery, useQuery } from '@apollo/client';
import { toast } from 'react-toastify';
import { GET_VALUATION } from '../graphql/Mutation/Topbar.js';
import SpinLoader from '../components/SpinLoader.js';
import TrackingHistoryModal from '../TrackCourier/TrackingHistoryModal.js';
import { LuCalculator, LuCircleArrowRight } from "react-icons/lu";
import { IoMdMail, IoMdPlanet } from 'react-icons/io';
import { GET_TRACKING_DOMESTIC } from '../graphql/Query/Advertise.js';
import { FaPlaneDeparture } from 'react-icons/fa';



const Mainone = () => {
  const { data: getvaluation, refetch: refetchValuation } = useQuery(GET_VALUATION);
  const [modalOpen, setModalOpen] = useState(false);
  const [shipmentData, setShipmentData] = useState(null);
  // console.log('✌️shipmentData --->', shipmentData);

  const [trackShipmentDomestic, { data, loading }] = useLazyQuery(GET_TRACKING_DOMESTIC, {
    fetchPolicy: "cache-and-network",
  });


  const validationSchema = Yup.object({
    awb: Yup.string().required('AWB number is required'),
  });

  const initialValues = {
    awb: '',
  };

  const handleChange = (e, setFieldValue) => {
    const cleanedValue = e.target.value.replace(/\s+/g, '');
    setFieldValue('awb', cleanedValue);
  };

  // ==============================Traking Number ==================

  const [activeTab, setActiveTab] = useState("india");

  const formik = useFormik({
    initialValues: {
      awbNumber: "",
    },
    validationSchema: Yup.object({
      awbNumber: Yup.string()
        .required("AWB Number is required")
        .min(5, "AWB must be at least 5 characters"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const { data } = await trackShipmentDomestic({
          variables: { awb: values.awbNumber.trim() }
        });

        if (data?.trackShipmentDomestic?.awb) {
          const shipment = data?.trackShipmentDomestic;

          // Transform transit_history to expected structure
          const parsedHistory = shipment?.transit_history?.map(scan => ({
            event_time: scan?.event_time
              ? new Date(Number(scan?.event_time)).toLocaleString()
              : '',
            location: scan?.location || '',
            message: scan?.remarks || scan?.status || ''
          }))?.reverse() || [];

          const trackingInfo = {
            details: {
              altReferenceNumber: shipment?.forwardingNumber,
              proof_of_delivery: shipment?.proof_of_delivery,
              last_center_details: shipment?.last_center_details
              //     destination: shipment.last_center_details || '',
              //     weight: '',        // Provide logic if available
              //     weightUnit: '',    // Provide logic if available
              //     consignee_name: shipment?.consignee_name || '',
              //     consignee_phone: shipment?.consignee_phone || '',
              //     delivered_at: shipment?.delivered_at || '',
              //     createdAt: shipment?.order?.createdAt || '',
              //     francise: shipment?.order?.franciseId || null
            },
            history: parsedHistory
          };
          setShipmentData(trackingInfo);  // Store the result in state
          setModalOpen(true);  // Show modal with shipment data
          resetForm();
        } else {
          toast.error("Shipment not found.");
        }
      } catch (error) {
        toast.error(error?.message || "Error fetching tracking details.");
      }
    },
  });
  return (
    <div>

      <div className="relative isolate overflow-hidden bg-slate-900 pt-4 pb-11 sm:pb-16 sm:pt-9">
        <img
          src="https://algarxpress.s3.ap-south-1.amazonaws.com/AlgarXpressImages/tailwindimg.avif"
          alt=""
          className="absolute inset-0 -z-10 h-full w-full object-cover object-right md:object-center"
        />
        <div
          className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl"
          aria-hidden="true"
        >
          <div
            className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>
        <div
          className="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu"
          aria-hidden="true"
        >
          <div
            className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
            style={{
              clipPath:
                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
            }}
          />
        </div>
        <div className="mx-auto max-w-auto  md:px-8 px-0">
          <div className="mx-auto max-w-2xl pt-4 sm:py-6 lg:max-w-none md:pt-5">
            <div className="mx-auto md:px-0 px-6 lg:mx-0">
              <h2 className="text-2xl font-bold tracking-tight sm:text-2xl text-white">Get your shipment picked up
                from your doorstep</h2>
              <p className="mt-2 leading-8 text-white">
                Send your parcel from the comfort of your home or office
              </p>
            </div>

            <div className="mb-7 mt-7 lg:mt-7 space-y-10 lg:grid lg:grid-cols-3  lg:gap-x-3 lg:space-y-0 ">
              <div className='md:rounded-lg rounded-none md:p-6 py-6 px-6  ring-1 ring-slate-900/5 shadow-md md:shadow-md bg-white justify-center'>
                <h2 className="text-xl font-bold text-gray-900">Ship Now </h2>
                <p className='text-slate-500 text-sm mt-1 mb-5'>We arrive at your doorstep
                  Our partners reach your location within 24 hours of placing the Shipment.</p>
                <div className='space-y-7'>
                  {/* <h1 className='text-sm font-medium'>1. All-India Shipment (0-30KG) | Door-to-Door (Pickup and Delivery) | From ₹34/500g</h1> */}
                  <div>
                    <h1 className='text-sm font-medium'>1. Domestic (All-India) Shipment Services : <span className='font-normal text-slate-600'> Door-to-Door (Pickup and Delivery)</span></h1>
                    <div className='grid grid-cols-3 mt-6 md:gap-y-7 gap-y-4 gap-x-3'>
                      <Link to='/documentshipping' state={{ key: false }}>
                        <div className=' hover:opacity-75 cursor-pointer'>
                          <IoMdMail className='text-5xl text-gray-700' />
                          <p className='font-semibold text-xs xl:text-sm text-slate-900'>Document</p>
                          <p className='font-normal  text-xs xl:text-sm text-slate-600'>(Domestic Service)</p>

                        </div></Link>
                      <Link to='/documentshipping' state={{ key: true }}>
                        <div className='hover:opacity-75 cursor-pointer'>
                          <BsBoxFill className='text-5xl p-1.5 text-gray-700 ' />
                          <p className='font-semibold  text-xs xl:text-sm text-slate-900'>Domestic's</p>
                          <p className='font-normal  text-xs xl:text-sm text-slate-600'>(Domestic Shipment Box)</p>
                        </div></Link>
                      {/* <Link to='/bulkcourier'>
                        <div className='hover:opacity-75 cursor-pointer'>
                          <FaBoxes className='text-5xl p-1.5 text-gray-700 ' />
                          <p className='font-semibold  text-xs xl:text-sm text-slate-900'>Bulk 0 to 30Kg</p>
                          <p className='font-normal  text-xs xl:text-sm text-slate-600'>(Domestic Multi Shipment Box)</p>

                        </div></Link> */}



                      <Link
                        to="/foreignair"
                        onClick={(e) => e.preventDefault()} // disable navigation
                        className="pointer-events-none opacity-50 cursor-not-allowed"
                      >
                        <div className="xl:mt-0 cursor-not-allowed">
                          <FaPlaneDeparture className="text-5xl text-gray-400 p-1" />
                          <p className="font-semibold text-xs xl:text-sm text-gray-400">India to Global</p>
                          <p className="font-normal text-xs xl:text-sm text-gray-400">(Export)</p>
                        </div>
                      </Link>

                      {/* <Link to='/sameday'> <div className='hover:opacity-75 cursor-pointer'>
                      <TbBikeFilled className='text-5xl p-0.5 text-gray-700 ' />
                      <p className='font-semibold  text-xs xl:text-sm text-slate-900'>Same Day Delivery</p>
                      <p className='font-normal  text-xs xl:text-sm text-slate-600'>(In-City Parcel by Bike)</p>
                    </div></Link> */}
                    </div>
                  </div>
                  {/* <div >
                    <h1 className='text-sm font-medium'>2.International (Worldwide) Shipment Services: <span className='font-normal text-slate-600'> Efficient Door-to-Door Pickup, Delivery (Export-Import)</span></h1>
                    <div className='grid grid-cols-3 md:grid-cols-3 mt-6 md:gap-y-7 gap-x-3 gap-y-4 lg:grid-cols-3 xl:grid-cols-3'>
                      <Link to='/foreignair'>
                        <div className=' xl:mt-0 hover:opacity-75 cursor-pointer'>
                          <FaPlaneDeparture className='text-5xl text-gray-800 p-1' />
                          <p className='font-semibold  text-xs xl:text-sm text-slate-900'>India to Global</p>
                          <p className='font-normal  text-xs xl:text-sm text-slate-600'>(Export)</p>

                        </div></Link>
                      <div className='xl:mt-0 opacity-35 cursor-not-allowed'>
                        <FaPlaneArrival className='text-5xl text-gray-800 p-1' />
                        <p className='font-semibold text-xs xl:text-sm text-slate-900'>Global to India</p>
                        <p className='font-normal text-xs xl:text-sm text-slate-600'>(Import)</p>
                      </div>

                    </div>
                  </div> */}
                </div>

                {/* <div className='mt-7'>
                  <h1 className='text-sm font-medium'>1. All-India Shipment (0-30KG) | Door-to-Door (Pickup and Delivery) | From ₹34/500g</h1>
                  <div className='grid grid-cols-3 md:grid-cols-3 mt-3 md:gap-y-7 gap-y-4 lg:grid-cols-3 xl:grid-cols-3'>
                    <Link to='/foreignair'>
                      <div className=' xl:mt-0 hover:opacity-75 cursor-pointer'>
                        <FaPlaneDeparture className='text-5xl text-gray-800 p-1' />
                        <p className='font-semibold  text-xs xl:text-sm text-slate-900'>India to Global</p>
                        <p className='font-semibold  text-xs xl:text-sm text-slate-500'>(Export)</p>

                      </div></Link>
                    <Link to='/foreignair'>
                      <div className=' xl:mt-0 hover:opacity-75 cursor-pointer'>
                        <FaPlaneArrival className='text-5xl text-gray-800 rotate- p-1' />
                        <p className='font-semibold  text-xs xl:text-sm text-slate-900'>Global to India</p>
                        <p className='font-semibold  text-xs xl:text-sm text-slate-500'>(Import)</p>

                      </div></Link>
                  </div>
                </div> */}


                <p className='text-sm font-semibold mt-7 md:block'>Book and track Shipment
                  anytime, anywhere</p>
              </div>

              <div className='md:rounded-lg  rounded-none md:p-6 py-6 px-6 ring-1 ring-slate-900/5 bg-white shadow-md md:shadow-md'>
                <h2 className="text-xl font-bold text-gray-900">Estimate Price?</h2>
                <p className='text-slate-500 text-sm mt-1 mb-5'>Reliable, Pan-India shipping
                  Quick pick-up and fast delivery across all over india.</p>
                {/* <h1 className='text-sm font-medium'>1. All-India Shipment (0-30KG) | Door-to-Door (Pickup and Delivery) | From ₹34/500g</h1> */}
                <div className='space-y-7'>
                  <div>
                    <h1 className='text-sm font-medium'>1. Domestic (All-India) Shipment Services : <span className='font-normal text-slate-600'> Door-to-Door (Pickup and Delivery)</span></h1>
                    <div className='grid grid-cols-2 mt-6 md:gap-y-7 gap-y-4 gap-x-3'>
                      <Link to="/calculatorcourier" state={{ keyy: false }}>
                        <div className="inline-flex flex-col hover:opacity-75 cursor-pointer">
                          <LuCalculator className="text-5xl mb-2 text-gray-700" />
                          <p className="font-semibold text-xs xl:text-sm text-slate-900">Domestics (India's)</p>
                          <p className="font-normal text-xs xl:text-sm text-slate-600">(Domestic Shipment)</p>
                        </div>
                      </Link>

                      <Link
                        to="/foreignair"
                        onClick={(e) => e.preventDefault()} // disable navigation
                        className="pointer-events-none opacity-50  cursor-default"
                      >
                        <div className="inline-flex flex-col cursor-not-allowed">
                          <div className="flex -space-x-2 items-end">
                            <LuCalculator className="text-5xl mb-2 text-gray-400" />
                            <IoMdPlanet className="text-3xl mb-2 text-gray-400 self-end" />
                          </div>
                          <p className="font-semibold text-xs xl:text-sm text-gray-400">Global (Worldwide)</p>
                          <p className="font-normal text-xs xl:text-sm text-gray-400">(International Shipment)</p>
                        </div>
                      </Link>

                    </div>
                  </div>
                  {/* <Link to='/calculatorcourier' state={{ keyy: true }}>
                    <div className='hover:opacity-75 cursor-pointer'>
                      <BsBoxFill className='text-5xl p-1.5 text-gray-800' />
                      <p className='font-semibold  text-xs xl:text-sm text-slate-900'>0 to 30Kg</p>
                      <p className='font-normal  text-xs xl:text-sm text-slate-600'>(Domestic Shipment Box)</p>
                    </div>
                  </Link> */}
                  {/* <div >
                    <h1 className='text-sm font-medium'>2. International (Worldwide) Shipment Services: <span className='font-normal text-slate-600'> Efficient Door-to-Door Pickup, Delivery (Export-Import)</span></h1>
                    <div className="mt-6 flex">
                      <Link to="/foreignair">
                        <div className="inline-flex flex-col hover:opacity-75 cursor-pointer">
                          <div className="flex -space-x-2 items-end">
                            <LuCalculator className="text-5xl mb-2 text-gray-700" />
                            <IoMdPlanet className="text-3xl mb-2 text-gray-700 self-end" />
                          </div>
                          <p className="font-semibold text-xs xl:text-sm text-slate-900">Global (Worldwide)</p>
                          <p className="font-normal text-xs xl:text-sm text-slate-600">(International Shipment)</p>
                        </div>
                      </Link>
                    </div>
                  </div> */}
                </div>

                <p className='text-sm font-semibold mt-7 md:block'>Fastest and reliable shipping anytime, anywhere</p>
              </div>

              <div className="md:rounded-lg rounded-none p-6 py-6 px-6 ring-1 bg-white ring-slate-900/5 shadow-md md:shadow-md">

                <div className="flex items-center space-x-3">
                  <FaBoxOpen className="h-6 w-6 text-slate-700" />
                  <h2 className="text-xl font-bold text-gray-900">
                    Can&apos;t find your delivery?
                  </h2>

                </div>

                <p className="text-sm mt-6 mb-6 text-gray-600">
                  Find your delivery using your Tracking AWB Number
                </p>

                {/* Tabs */}
                <div className="flex border-b my-4 border-gray-200">
                  <button
                    type="button"
                    onClick={() => setActiveTab("india")}
                    className={`px-4 py-2 text-sm font-medium ${activeTab === "india"
                      ? "text-black border-b-2 border-black bg-blue-50"
                      : "text-gray-500 hover:text-gray-700"
                      }`}
                  >
                    India&apos;s Shipment
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab("global")}
                    className={`px-4 py-2 text-sm font-medium ${activeTab === "global"
                      ? "text-black border-b-2 border-black bg-blue-50"
                      : "text-gray-500 hover:text-gray-700"
                      }`}
                  >
                    Global Shipment
                  </button>
                </div>

                {/* Form */}
                <form onSubmit={formik.handleSubmit}>
                  <div>
                    <label
                      htmlFor="awbNumber"
                      className="block text-sm mb-1 font-medium text-gray-700"
                    >
                      Tracking (AWB) Number <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="awbNumber"
                      name="awbNumber"
                      type="text"
                      placeholder="Enter Your AWB Number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.awbNumber}
                      className={`mt-1 block w-full rounded-md border px-3 py-2 shadow-sm focus:outline-none sm:text-sm ${formik.touched.awbNumber && formik.errors.awbNumber
                        ? "border-red-500 focus:ring-red-500"
                        : "border-gray-600 focus:ring-blue-500"
                        }`}
                    />
                    {formik.touched.awbNumber && formik.errors.awbNumber && (
                      <p className="mt-1 text-sm text-red-500">
                        {formik.errors.awbNumber}
                      </p>
                    )}
                  </div>


                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full rounded-md mt-6 bg-slate-900 px-4 py-2 text-white font-semibold shadow hover:bg-slate-800 focus:outline-none"
                  >
                    <span className="flex items-center justify-center gap-2">
                      Track Now <LuCircleArrowRight /> {loading && (
                        <SpinLoader classNamecolor="true" />
                      )}
                    </span>
                  </button>

                </form>

                <p className="text-center mt-4 text-sm text-gray-600">
                  Ship and track from the comfort of your home
                </p>
              </div>
              {modalOpen && shipmentData && (
                <TrackingHistoryModal
                  trackingInfo={shipmentData}
                  modalOpen={modalOpen}
                  setModalOpen={setModalOpen}
                />
              )}
            </div>


          </div>
          <div className="mx-auto mt-1 md:mt-0 max-w-2xl px-6 md:px-0 lg:mx-0 lg:max-w-none">
            <dl className="grid grid-cols-1 gap-8 md:mt-13 sm:grid-cols-2 lg:grid-cols-5">
              {getvaluation?.getTopBarValuation?.length > 0 && getvaluation?.getTopBarValuation?.map((stat) => (
                <div key={stat.topBar} className="flex flex-col-reverse">
                  <dt className="text-base leading-7 text-gray-300 md:text-[14px] md:leading-6">{stat?.topBar}</dt>
                  <dd className="text-2xl font-bold leading-9 tracking-tight text-white">{stat?.content}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Mainone
